import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LoginApiService} from '../services/api/login/login-api.service';

@Injectable()
export class AzureResolver implements Resolve<any> {
    constructor(private loginApiService: LoginApiService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return this.loginApiService.isAzureEnabled().then(data => {
            return data;
        }).catch(() => {
            return {
                enabled: false
            };
        });
    }

}
